/*  =============================================
    Copyright © Hugo B.V. (acting under the brand name "Quriobot") - All Rights Reserved
    =============================================

    - Unauthorized copying of this file, via any medium is strictly prohibited
    - Proprietary and confidential
    - By using the Quriobot Website and/or Services, you signify you have read and
      accepted the Terms of Service on https://quriobot.com/terms of this Website and Services.
      If you do not agree to these Conditions, do not use Quriobot Website and/or Services.
    - Written by the good people of Hugo B.V. (acting under the brand name "Quriobot"), hello@quriobot.com, December 2016

    ============================================= */

var PanelLogin = new Class({
  Extends: QuriobotElement,
  template: function () {
    var base =
      '<div class="panel--wrapper panel--login holds--data isLoading" family="{{ key }}" id="{{ eid }}">' +
      '    <div class="panel--main">' +
      '        <div class="panel--content">' +
      '            <div class="login--header">' +
      '                <div class="login--icon">' +
      '                    <span class="lock--body">' +
      '                        <span class="lock--keyhole"></span>' +
      '                    </span>' +
      '                </div>' +
      '                <p>' +
      '                {% header_text %}' +
      '                </p>' +
      '            </div>' +
      '            <div class="login--form">' +
      '                <div class="login--error"></div>' +
      '                <form>{% options %}</form>' +
      '            </div>' +
      '            <div class="login--footer">' +
      '            <button class="go--button">' +
      '                <p class="go--button__text">{% go_button_text %}</p>' +
      '                <div class="goarrow">' +
      '                    <div class="goarrow--body"></div>' +
      '                </div>' +
      '            </button>' +
      '            </div>' +
      '        </div>' +
      '        <div class="panel--overlay">' +
      '            <div class="icon--checkWrapper fromBottom circle">' +
      '                <div class="check"></div>' +
      '            </div>' +
      '            <button type="button" aria-label="' +
      this.data.i18n.redo.button.title +
      '" aria-hidden="true" class="icon--redoWrapper">' +
      '                <div class="redo"></div>' +
      '            </button>' +
      '        </div>' +
      '    </div>' +
      '</div>'

    var username =
      '<div class="inline--input">' +
      '   <label for="id_username">{{str}}</label>' +
      '   <input type="text" id="id_username" name="username" placeholder="{{str}}" />' +
      '</div>'

    var password =
      '<div class="inline--input">' +
      '    <label for="id_password">{{str}}</label>' +
      '    <input type="password" id="id_password" name="password" placeholder="{{str}}" />' +
      '</div>'

    var twostep =
      '<div class="inline--input">' +
      '    <label for="id_twostep">{{str}}</label>' +
      '    <input type="text" id="id_twostep" name="twostep" placeholder="{{str}}" />' +
      '</div>'

    return {
      base: base,
      username: username,
      password: password,
      twostep: twostep,
    }
  },
  attach: function () {
    this.submitButton = this.element.getElements('button')[0]
    this.submitForm = this.element.getElements('form')[0]
    this.formError = this.element.getElements('.login--error')[0]
    this.fields = this.element.getElements('input')

    this.submitForm.addEvents({
      submit: function (e) {
        e.preventDefault()
        e.stopPropagation()
        this.validate()
      }.bind(this),
    })
    this.submitButton.addEvents({
      click: function (e) {
        e.preventDefault()
        e.stopPropagation()
        this.validate()
      }.bind(this),
    })

    this.fields.each(function (oField) {
      oField.addEvents({
        keyup: function () {
          if (oField.get('value')) {
            oField.getParent().addClass('hasData')
          } else {
            oField.getParent().removeClass('hasData')
          }
        }.bind(this),
        blur: function () {
          if (oField.get('value')) {
            oField.getParent().addClass('hasData')
          } else {
            oField.getParent().removeClass('hasData')
          }
        }.bind(this),
      })
    })
  },
  validate: function (results) {
    if (!results) {
      this.formError.removeClass('show')
      if (this.fields.length) {
        var is_empty = this.fields.filter(function (oInput) {
          return !oInput.get('value') || oInput.get('value') == ''
        })

        if (is_empty.length > 0) {
          return
        }
      }

      var uname = this.fields.filter(function (oInput) {
        return oInput.get('name') == 'username'
      })

      var pword = this.fields.filter(function (oInput) {
        return oInput.get('name') == 'password'
      })

      var twstp = this.fields.filter(function (oInput) {
        return oInput.get('name') == 'twostep'
      })

      var apiData = {
        type: this.api.putType,
      }

      if (uname.length > 0) {
        apiData.username = uname[0].get('value')
      }
      if (pword.length > 0) {
        apiData.password = pword[0].get('value')
      }
      if (twstp.length > 0) {
        apiData.twstp = twstp[0].get('value')
      }
      this.element.addClass('isWaiting')
      this.apiCallback(apiData, this.validate.bind(this))
      return
    }
    this.element.removeClass('isWaiting')
    if (results.data.success) {
      this.success(results.data.data)
    } else {
      this.error(results.data)
    }
    return
  },
  error: function (data) {
    var message = data.data.error
    this.formError.set('html', message)
    this.formError.addClass('show')
  },
  success: function (result) {
    this.loginData = result
    this.after()
  },
  after: function () {
    var answerData = {
      answer: {
        render: false,
        value: this.loginData,
        content: 'successfull login for user ' + this.loginData,
      },
    }
    this.element.addClass('isAnswered')
    this.answerCallback(this.data, answerData)
  }
})
